export default "__VITE_ASSET__CodTx9HP__"